/** @file A segment's shape in segment-normalized form (ease), ready to copy onto other selected keys. */
import type { Curve } from '@pose2d/format/types';
import { curveSegment } from './curveSegment';
import type { CurveTrack } from './curveTypes';

/** linear/stepped/ease as stored; a bezier as the ease it draws; null for a bezier on a segment that keeps its value. */
export function curveEaseShape(track: CurveTrack, i: number): Curve | null {
  const curve = track.curves[i] ?? 'linear';
  if (typeof curve === 'string' || 'ease' in curve) return curve;
  const [v0, v1] = curveSegment.ends(track, i);
  if (Math.abs(v1 - v0) <= 1e-12) return null;
  const [x1, d1, x2, d2] = curve.bezier;
  return { ease: [x1, d1 / (v1 - v0), x2, d2 / (v1 - v0)] };
}
